/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { Breadcrumbs, Inline, PlaceholderText } from 'sarsaparilla';

import type { BreadcrumbPath } from './SharedVenuePage.types';

export interface BreadcrumbsContainerProps {
    path: BreadcrumbPath[];
    isLoading?: boolean;
}

export function BreadcrumbsContainer({
    path = [],
    isLoading = false,
}: BreadcrumbsContainerProps) {
    if (isLoading) {
        return (
            <Inline className="rec-breadcrumb-wrap">
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
                <span> / </span>
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
                <span> / </span>
                <PlaceholderText fontSize={20} lineHeight={23} width="150px" />
            </Inline>
        );
    }

    if (!path || path.length === 0) {
        return null;
    }

    return (
        <div className="rec-breadcrumb-wrap">
            <Breadcrumbs path={path} />
        </div>
    );
}
